function t(r) {
  return {
    generalHightlight: r.general.highlight,
    hightLighHightlight: r.general.highlightHighlight,
    accentColor: r.general.primaryButtonBackground,
    font: r.font,
    header: {
      textColor: r.general.highlightText,
      primaryColor: r.general.highlightBackground,
      borderColor: r.general.highlightLines
    },
    content: {
      backgroundColor: r.general.background,
      textColor: r.general.text,
      borderColor: r.general.lines,
      primaryButtonText: r.general.primaryButtonText,
      primaryButtonBackground: r.general.primaryButtonBackground,
      secondaryButtonBackground: r.general.secondaryButtonBackground,
      secondaryButtonText: r.general.secondaryButtonText,
      userProfileBackground: r.general.userProfileBackground
    }
  };
}
export {
  t as mapSharedLandingDesignToNavbar
};
//# sourceMappingURL=utils.js.map
